import { render, staticRenderFns } from "./buyModal.vue?vue&type=template&id=5be799f0&scoped=true&"
import script from "./buyModal.vue?vue&type=script&lang=js&"
export * from "./buyModal.vue?vue&type=script&lang=js&"
import style0 from "./buyModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./buyModal.vue?vue&type=style&index=1&id=5be799f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be799f0",
  null
  
)

export default component.exports